import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import Textarea from 'components/common/textarea-field';
import PrimaryDarkButton from 'components/common/buttons/primary-dark-btn';
import DarkButton from 'components/common/buttons/dark-btn';
import InputField from 'components/common/input-field';
import { setModal } from 'store/features/modelSlice';
import { initModal } from 'helpers/utils';
import Select, { IDefaultOption } from 'components/common/select';
import { useContext, useEffect, useState } from 'react';
import {
  IAlertDropdownOption,
  IAlertTemplateItem,
  getAlertsTemplates,
  createAlertTemplates,
  setAlertsTemplates,
  setSelectAlertTemplate,
  createProgrammedAlerts,
  getProgrammedAlerts,
  updateProgrammedAlerts,
} from 'store/features/alertsSlice';
import { AppContext } from 'context/app-context';
import toast from 'react-hot-toast';
import {
  getBrandList,
  getEngineList,
  // getModelsList,
  getTireSizeList,
} from 'store/features/vehicleConfigSlice';
import { ReactComponent as TrashIcon } from 'assets/icon/trash.svg';
import { ICondition, IProgrammedAlertsRequest } from 'interfaces/alerts-campaigns-interface';
import {
  programmedAlertConditions,
  programmedAlertConditionsForTime,
  programmedAlertFields,
} from 'helpers/constant';
import { useTranslation } from 'react-i18next';

interface ISendAlertsData {
  brand?: IDefaultOption | null;
  model?: IDefaultOption | null;
  engine?: IDefaultOption | null;
  frontTireSize?: IDefaultOption | null;
  rearTireSize?: IDefaultOption | null;
  selectedAlert: IAlertDropdownOption | null;
  alertDetails: IAlertTemplateItem;
}

const initAlertDetails = {
  title: '',
  description: '',
  referenceCode: '',
};

interface IError {
  alertTitle?: string;
  alertDescription?: string;
  referenceCode?: string;
}
const AddEditProgrammedAlert = () => {
  const { setLoader } = useContext(AppContext);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { alertsTemplates, selectedAlert, selectedProgrammedAlert } = useAppSelector(
    state => state.alerts,
  );

  const { brands, engines, models, tireSizes } = useAppSelector(state => state.vehicleConfig);
  const {
    modal: {
      content: { title, formFor },
    },
  } = useAppSelector(state => state.modal);

  const [alertsData, setAlertsData] = useState<ISendAlertsData | null>(
    selectedAlert
      ? {
          selectedAlert: {
            id: selectedAlert?.id || '',
            name: selectedAlert?.title || '',
            value: selectedAlert?.description || '',
          },
          alertDetails: {
            description: selectedAlert?.description || '',
            title: selectedAlert?.title || '',
            id: selectedAlert?.id || '',
            referenceCode: selectedAlert?.referenceCode || '',
          },
        }
      : null,
  );
  const [error, setError] = useState<IError | null>(null);
  const [dropdownSearch, setDropdownSearch] = useState<string>('');
  const [brandOptions, setBrandOptions] = useState<IDefaultOption[]>([]);
  // const [modelOptions, setModelOptions] = useState<IDefaultOption[]>([]);
  const [engineOptions, setEngineOptions] = useState<IDefaultOption[]>([]);
  const [tireSizeOptions, settireSizeOptions] = useState<IDefaultOption[]>([]);
  const [conditions, setConditions] = useState<ICondition[]>([
    { field: null, condition: null, value: '' },
  ]);
  const fetchOptions = async () => {
    try {
      setLoader(true);
      await Promise.all([
        dispatch(getBrandList({})),
        // dispatch(getModelsList({})),
        dispatch(getEngineList({})),
        dispatch(getTireSizeList({})),
        dispatch(getAlertsTemplates()),
      ]).catch(() => setLoader(false));
      setLoader(false);
    } catch (error) {}
  };
  useEffect(() => {
    fetchOptions();
    if (formFor === 'EDIT') {
      const updatedAlertData: ISendAlertsData = {
        selectedAlert: alertsData?.selectedAlert!,
        alertDetails: {
          description: selectedProgrammedAlert?.description!,
          title: selectedProgrammedAlert?.title!,
          _id: selectedProgrammedAlert?._id,
          id: selectedProgrammedAlert?._id,
          referenceCode: selectedProgrammedAlert?.alert_ref || '',
        },
        brand: selectedProgrammedAlert?.brandDetails
          ? {
              id: selectedProgrammedAlert?.brandDetails?._id!,
              name: selectedProgrammedAlert?.brandDetails?.name!,
              value: selectedProgrammedAlert?.brandDetails?._id,
            }
          : null,
        model: selectedProgrammedAlert?.modelDetails
          ? {
              id: selectedProgrammedAlert?.modelDetails?._id!,
              name: selectedProgrammedAlert?.modelDetails?.name!,
              value: selectedProgrammedAlert?.modelDetails?._id,
            }
          : null,
        frontTireSize: selectedProgrammedAlert?.frontTireSizeDetails
          ? {
              id: selectedProgrammedAlert?.frontTireSizeDetails?._id!,
              name: selectedProgrammedAlert?.frontTireSizeDetails?.name!,
              value: selectedProgrammedAlert?.frontTireSizeDetails?._id,
            }
          : null,
        rearTireSize: selectedProgrammedAlert?.rearTireSizeDetails
          ? {
              id: selectedProgrammedAlert?.rearTireSizeDetails?._id!,
              name: selectedProgrammedAlert?.rearTireSizeDetails?.name!,
              value: selectedProgrammedAlert?.rearTireSizeDetails?._id,
            }
          : null,
        engine: selectedProgrammedAlert?.engineDetails
          ? {
              id: selectedProgrammedAlert?.engineDetails?._id!,
              name: selectedProgrammedAlert?.engineDetails?.name!,
              value: selectedProgrammedAlert?.engineDetails?._id,
            }
          : null,
      };
      if (selectedProgrammedAlert?.conditions?.length) {
        const updatedConditions: ICondition[] = selectedProgrammedAlert?.conditions.map(data => ({
          field: programmedAlertFields?.find(item => item?.value === data.field) || null,
          condition:
            data.field === 'TIME'
              ? [...programmedAlertConditionsForTime].find(
                  item => item?.value === data.condition,
                ) || null
              : [...programmedAlertConditions]?.find(item => item?.value === data.condition) ||
                null,
          value: data.value,
        }));
        setConditions(updatedConditions);
      }
      setAlertsData(updatedAlertData);
    }
  }, []);
  useEffect(() => {
    const formatedBrandOptions =
      brands.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setBrandOptions(formatedBrandOptions);
  }, [brands]);
  // useEffect(() => {
  //   const formatedModelOptions =
  //     models.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
  //   setModelOptions(formatedModelOptions);
  // }, [models]);
  useEffect(() => {
    const formatedEngineOptions =
      engines.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    setEngineOptions(formatedEngineOptions);
  }, [engines]);
  useEffect(() => {
    const formatedTireSizeOptions =
      tireSizes.map(data => ({ id: data?._id || '', name: data?.name || '' })) || [];
    settireSizeOptions(formatedTireSizeOptions);
  }, [tireSizes]);

  // const handleChange = (field: string, value: string | IOrganizationAssociateParking | IRoles) => {
  //   let updatedData = { ...adminRoles };
  //   updatedData = { ...updatedData, [field]: value };
  //   if (field === 'role') {
  //     updatedData = { ...updatedData, associated_company: '' };
  //   }
  //   setAdminRoles(updatedData);
  // };

  const handleChange = (field: string, value: IAlertDropdownOption) => {
    const updatedValue: ISendAlertsData = {
      ...alertsData,
      selectedAlert: alertsData?.selectedAlert ? alertsData?.selectedAlert : null,
      alertDetails:
        field === 'selectedAlert'
          ? { title: value.name || '', description: value?.value || '', referenceCode: '' }
          : alertsData?.alertDetails
          ? alertsData?.alertDetails
          : initAlertDetails,
      [field]: value,
    };
    setAlertsData(updatedValue ? updatedValue : null);
  };
  const getRequestData = () => {
    let request: IProgrammedAlertsRequest = {
      title: alertsData?.alertDetails?.title!,
      description: alertsData?.alertDetails?.description!,
      alert_ref: alertsData?.alertDetails?.referenceCode!,
    };
    if (alertsData?.brand) {
      request.brand = alertsData?.brand?.id;
    }
    if (alertsData?.engine) {
      request.engine = alertsData?.engine?.id;
    }
    if (alertsData?.frontTireSize) {
      request.frontTireSize = alertsData?.frontTireSize?.id;
    }
    if (alertsData?.rearTireSize) {
      request.rearTireSize = alertsData?.rearTireSize?.id;
    }
    // if (alertsData?.model) {
    //   request.model = alertsData?.model?.id;
    // }
    if (formFor === 'EDIT') {
      request = {
        ...request,
        alert_id: alertsData?.alertDetails?._id || alertsData?.alertDetails?.id,
      };
    }
    if (conditions?.filter(data => data?.value.trim()).length > 0) {
      const updatedConditions = conditions
        ?.filter(data => data?.value.trim())
        .map(data => ({
          field: data?.field?.value!,
          condition: data?.condition?.value!,
          value: data?.value,
        }));
      request = { ...request, conditions: updatedConditions };
    }
    return request;
  };
  const handleCreateAlert = async () => {
    try {
      const request = getRequestData();
      setLoader(true);
      await dispatch(
        createProgrammedAlerts({
          request: {
            ...request,
          },
        }),
      ).then(() => {
        dispatch(getProgrammedAlerts({}));
        dispatch(setSelectAlertTemplate(null));
        dispatch(setModal(initModal));
        setLoader(false);
        toast.success(t('programmed_alerts.successAlterCreateToastMessage'));
      });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleEditAlert = async () => {
    try {
      const request = getRequestData();
      setLoader(true);
      await dispatch(
        updateProgrammedAlerts({
          request: {
            ...request,
          },
        }),
      ).then(() => {
        dispatch(getProgrammedAlerts({}));
        dispatch(setSelectAlertTemplate(null));
        dispatch(setModal(initModal));
        setLoader(false);
        toast.success(t('programmed_alerts.successAlertUpdateToatMessage'));
      });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleSaveTemplate = () => {
    try {
      if (
        !alertsData?.alertDetails?.title?.trim() ||
        !alertsData?.alertDetails?.description.trim()
      ) {
        toast.error(t('programmed_alerts.errorAlertToastMessage'));
        setError({
          alertTitle: !alertsData?.alertDetails?.title?.trim()
            ? t('programmed_alerts.errorAlertTitleToastMessage')
            : '',
          alertDescription: !alertsData?.alertDetails?.description?.trim()
            ? t('programmed_alerts.errorAlertDescToastMessage')
            : '',
        });
        return;
      }
      setLoader(true);
      dispatch(
        createAlertTemplates({
          request: {
            title: alertsData?.alertDetails?.title,
            description: alertsData?.alertDetails?.description,
          },
        }),
      ).then(response => {
        dispatch(
          setAlertsTemplates([
            ...alertsTemplates,
            {
              id: response?._id || '',
              title: response?.title || '',
              description: response?.description || '',
              referenceCode: response?.referenceCode || '',
            },
          ]),
        );
        setAlertsData({
          ...alertsData,
          alertDetails: {
            ...alertsData?.alertDetails,
            id: response?._id || '',
            title: response?.title || '',
            description: response?.description || '',
          },
          selectedAlert: {
            id: response?._id || '',
            name: response?.title || '',
            value: response?.description || '',
          },
        });
        setLoader(false);
      });
    } catch (error) {
      setLoader(false);
    }
  };
  const handleGenerateAlert = () => {
    try {
      if (
        !alertsData?.alertDetails?.title.trim() ||
        !alertsData?.alertDetails?.description?.trim() ||
        !alertsData?.alertDetails?.referenceCode?.trim()
      ) {
        toast.error(t('programmed_alerts.errorAlertToastMessage'));
        setError({
          alertTitle: !alertsData?.alertDetails?.title?.trim()
            ? t('programmed_alerts.errorAlertTitleToastMessage')
            : '',
          alertDescription: !alertsData?.alertDetails?.description?.trim()
            ? t('programmed_alerts.errorAlertDescToastMessage')
            : '',
          referenceCode: !alertsData?.alertDetails?.referenceCode?.trim()
            ? t('programmed_alerts.errorRefCodeToastMessage')
            : '',
        });
        return;
      }
      if (formFor === 'EDIT') {
        handleEditAlert();
      } else {
        handleCreateAlert();
      }
    } catch {}
  };
  const getSaveTemplateButtonDisable = () => {
    if (!alertsData?.alertDetails?.title.trim() || !alertsData?.alertDetails?.description.trim()) {
      return true;
    } else if (
      alertsData?.selectedAlert &&
      alertsData?.alertDetails &&
      alertsData?.selectedAlert?.name === alertsData?.alertDetails?.title &&
      alertsData?.selectedAlert?.value === alertsData?.alertDetails?.description
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getConditionValuePlaceholder = (field: string) => {
    switch (field) {
      case 'KM':
        return t('programmed_alerts.conditionValueKM');
      case 'TIME':
        return t('programmed_alerts.conditionValueTime');
      default:
        return t('programmed_alerts.conditionValueDefault');
    }
  };
  const handleCancel = () => {
    dispatch(setSelectAlertTemplate(null));
    dispatch(setModal(initModal));
  };
  return (
    <div className="flex flex-col max-h-[calc(100vh-180px)] w-[600px] gap-y-4 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">{title}</label>
        </div>
        <div className="flex items-center justify-center cursor-pointer" onClick={handleCancel}>
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <div className="flex flex-wrap w-full overflow-y-auto flex-1 gap-y-1">
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('BRAND')}</label>
          <Select
            placeholder={t('campaigns.placeholder_brand')}
            selected={alertsData?.brand || null}
            options={
              brandOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('brand', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                selectedAlert: null,
                alertDetails: initAlertDetails,
                brand: null,
              });
            }}
          />
        </div>
        {/* <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-1/2w-full">{t('MODEL')}</label> */}
        {/* <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-1/2w-full">Model</label>
          <Select
            placeholder={t('campaigns.placeholder_model')}
            selected={alertsData?.model || null}
            options={
              modelOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('model', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
          />
        </div> */}
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('ENGINE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_engine')}
            selected={alertsData?.engine || null}
            options={
              engineOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('engine', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                selectedAlert: null,
                alertDetails: initAlertDetails,
                engine: null,
              });
            }}
          />
        </div>
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('FRONT_TIRE_SIZE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_front_tire')}
            selected={alertsData?.frontTireSize || null}
            options={
              tireSizeOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('frontTireSize', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                selectedAlert: null,
                alertDetails: initAlertDetails,
                frontTireSize: null,
              });
            }}
          />
        </div>
        <div className="w-1/2 px-1">
          <label className="font-medium text-xs text-black2 w-full">{t('REAR_TIRE_SIZE')}</label>
          <Select
            placeholder={t('campaigns.placeholder_rear_tire')}
            selected={alertsData?.rearTireSize || null}
            options={
              tireSizeOptions.filter(
                item => item?.name?.toLowerCase().startsWith(dropdownSearch.toLowerCase()),
              ) || []
            }
            setSelected={data => handleChange('rearTireSize', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                selectedAlert: null,
                alertDetails: initAlertDetails,
                rearTireSize: null,
              });
            }}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('alerts.alert_template_btn')}
          </label>
          <Select<IAlertDropdownOption>
            placeholder={t('alerts.alert_template_btn')}
            selected={alertsData?.selectedAlert || null}
            options={
              [...alertsTemplates]
                .filter(item => item?.title?.toLowerCase().startsWith(dropdownSearch.toLowerCase()))
                .map(data => ({
                  name: data?.title || '',
                  id: data?.id || '',
                  value: data?.description || '',
                })) || []
            }
            setSelected={data => handleChange('selectedAlert', data)}
            isSearchable
            search={dropdownSearch}
            setSearch={data => setDropdownSearch(data)}
            removeSearchOnBlur={true}
            showCross
            handleCross={() => {
              setAlertsData({
                ...alertsData,
                selectedAlert: null,
                alertDetails: initAlertDetails,
              });
            }}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('alerts.tableHeaders.referanceCode')}
          </label>
          <InputField
            onChange={data =>
              setAlertsData({
                ...alertsData,
                selectedAlert: alertsData?.selectedAlert ? alertsData?.selectedAlert : null,
                alertDetails: {
                  title: alertsData?.alertDetails?.title || '',
                  id: alertsData?.alertDetails?.id,
                  description: alertsData?.alertDetails?.description || '',
                  referenceCode: data || '',
                },
              })
            }
            error={error?.referenceCode}
            value={alertsData?.alertDetails?.referenceCode || ''}
            placeholder={t('alerts.tableHeaders.referanceCodePlaceholder')}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('generated_alert.tableHeaders.title')}
          </label>
          <InputField
            onChange={data =>
              setAlertsData({
                ...alertsData,
                selectedAlert: alertsData?.selectedAlert ? alertsData?.selectedAlert : null,
                alertDetails: {
                  title: data || '',
                  id: alertsData?.alertDetails?.id,
                  description: alertsData?.alertDetails?.description || '',
                  referenceCode: alertsData?.alertDetails?.referenceCode || '',
                },
              })
            }
            error={error?.alertTitle}
            value={alertsData?.alertDetails?.title || ''}
            placeholder={t('alerts.tableHeaders.alertTitle')}
          />
        </div>
        <div className="w-full">
          <label className="font-medium text-xs text-black2 w-full">
            {t('generated_alert.tableHeaders.description')}
          </label>
          <Textarea
            onChange={data =>
              setAlertsData({
                ...alertsData,
                selectedAlert: alertsData?.selectedAlert ? alertsData?.selectedAlert : null,
                alertDetails: {
                  title: alertsData?.alertDetails?.title || '',
                  id: alertsData?.alertDetails?.id,
                  description: data || '',
                  referenceCode: alertsData?.alertDetails?.referenceCode || '',
                },
              })
            }
            value={alertsData?.alertDetails?.description || ''}
            error={error?.alertDescription}
            row={2}
            placeholder={t('generated_alert.tableHeaders.descriptionPlaceholder')}
          />
        </div>
        <div className="flex items-center w-full flex-wrap mt-2 bg-grey4 px-2 py-2 rounded-2">
          <div className="flex items-center w-full mb-2">
            <label className="text-base font-medium w-full">
              {t('programmed_alerts.conditions')}
            </label>
          </div>
          {conditions.map((data, index) => (
            <div className="flex items-center gap-x-2 mt-1 w-full" key={index}>
              <div className="w-4/12 flex items-center justify-center">
                <Select
                  placeholder={t('programmed_alerts.conditionPlaceholder2')}
                  selected={data?.field}
                  setSelected={selected => {
                    const updatedCondition = conditions.map((data, innerIndex) => ({
                      condition: index === innerIndex ? null : data?.condition!,
                      value: index === innerIndex ? '' : data?.value,
                      field:
                        index === innerIndex
                          ? { id: selected.id, name: selected?.name, value: selected?.value }
                          : data.field,
                    }));
                    setConditions(updatedCondition);
                  }}
                  options={programmedAlertFields}
                  dropdownPlacement="TOP"
                />
              </div>
              <div className="w-3/12 flex items-center justify-center">
                <Select
                  placeholder={t('programmed_alerts.conditionPlaceholder2')}
                  selected={data.condition}
                  setSelected={selected => {
                    const updatedCondition = conditions.map((data, innerIndex) => ({
                      value: data?.value,
                      field: data?.field,
                      condition:
                        index === innerIndex
                          ? { id: selected.id, name: selected?.name, value: selected?.value }
                          : data.condition,
                    }));
                    setConditions(updatedCondition);
                  }}
                  options={
                    data?.field?.value === 'TIME'
                      ? programmedAlertConditionsForTime
                      : programmedAlertConditions
                  }
                  dropdownPlacement="TOP"
                />
              </div>
              <div className="w-4/12 flex items-center justify-center">
                <InputField
                  placeholder={getConditionValuePlaceholder(data?.field?.value!)}
                  value={data.value}
                  onChange={val => {
                    const updatedCondition = conditions.map((data, innerIndex) => ({
                      condition: data?.condition,
                      field: data?.field,
                      value: index === innerIndex ? val : data.value,
                    }));
                    setConditions(updatedCondition);
                  }}
                />
              </div>
              <div
                className="flex items-center justify-center cursor-pointer w-1/12"
                onClick={() => {
                  let updatedData = [...conditions].filter((data, i) => i !== index);
                  setConditions(updatedData);
                }}
              >
                <TrashIcon color="red" height={18} width={18} />
              </div>
            </div>
          ))}
          <div className="flex w-full items-center mt-5">
            <PrimaryDarkButton
              label={t('programmed_alerts.primaryButtonLabel')}
              onClick={() => {
                if (conditions.find(item => !item?.value.trim())) {
                  toast.error(t('programmed_alerts.errorConditionToastMessage'));
                  return;
                } else {
                  setConditions([...conditions, { condition: null, field: null, value: '' }]);
                }
              }}
              height="h-7"
              width="w-2/7"
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center w-full gap-x-4 mt-4">
        <PrimaryDarkButton
          label={t('programmed_alerts.darkBtnLabel')}
          onClick={() => handleSaveTemplate()}
          width="w-1/3"
          background="bg-[#4E647D]"
          disabled={getSaveTemplateButtonDisable()}
        />
        <PrimaryDarkButton
          label={
            formFor === 'EDIT'
              ? t('programmed_alerts.editAlert')
              : t('programmed_alerts.createAlert')
          }
          onClick={() => handleGenerateAlert()}
          width="w-1/3"
        />
        <DarkButton label={t('CANCEL')} width="w-1/3" onClick={handleCancel} />
      </div>
    </div>
  );
};

export default AddEditProgrammedAlert;
